const FORM_TRIGGER_SELECTOR = [
  '.web-form-submit',
  '.form__input',
  '.dropzone-area',
  '[data-scroll-to-form]',
].join(', ');

let formsPromise = null;

function getTrigger(event) {
  if (!(event.target instanceof Element)) {
    return null;
  }

  if (event.type === 'submit' && event.target instanceof HTMLFormElement) {
    return event.target;
  }

  return event.target.closest(FORM_TRIGGER_SELECTOR);
}

function redispatch(trigger, event) {
  if (!trigger || !['click', 'submit', 'keyup', 'change', 'input'].includes(event.type)) {
    return;
  }

  trigger.dispatchEvent(new Event(event.type, {
    bubbles: true,
    cancelable: true,
  }));
}

async function loadForms() {
  if (!formsPromise) {
    formsPromise = import('../modules/forms.js').then((module) => module.initForms());
  }

  return formsPromise;
}

export function initFormBootstrap(root = document) {
  const ownerDocument = root.ownerDocument || document;
  const html = ownerDocument.documentElement;

  if (html.dataset.webtenseFormBootstrapInit) {
    return;
  }

  html.dataset.webtenseFormBootstrapInit = 'true';

  const handleEvent = async (event) => {
    if (html.dataset.webtenseFormsInit === 'true') {
      return;
    }

    const trigger = getTrigger(event);
    if (!trigger) {
      return;
    }

    if (['click', 'submit'].includes(event.type)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    await loadForms().catch(() => null);
    redispatch(trigger, event);
  };

  ['click', 'submit', 'focusin', 'keyup', 'change', 'input', 'dragenter'].forEach((eventName) => {
    ownerDocument.addEventListener(eventName, handleEvent, true);
  });
}
